import * as Team from "src/state/modules/team";
import { IconProps, IconSize } from "./icon-prop-types";
import * as Icons from "./icons";

const RSVPIconMap = {
  going: Icons.GoingIcon,
  notGoing: Icons.NotGoingIcon,
  noResponse: Icons.NoResponseIcon,
  people: Icons.PeopleIcon,
};

const InviteStatusIconMap = {
  //invited: Icons.InvitedIcon,
  //notInvited: Icons.NotInvitedIcon,
};

const StatusIconMap = {
  //success: Icons.SuccessIcon,
  error: Icons.ErrorIcon,
};

const SportIconMap: {
  [key in Team.Sport]: (typeof Icons)["BaseballIcon"];
} = {
  [Team.Sport.BASEBALL]: Icons.BaseballIcon,
  [Team.Sport.SOFTBALL]: Icons.SoftballIcon,
  [Team.Sport.OTHER]: Icons.BaseballIcon,
};

//type OrganizationSupportedSports = Sport;

const CompetitionLevelIconMap = {
  //[CompetitionLevel.SCHOOL]: Icons.SchoolIcon,
  //[CompetitionLevel.CLUB_TRAVEL]: Icons.TravelIcon,
  //[CompetitionLevel.RECREATIONAL]: Icons.RecreationalIcon,
};

const AgeRangeIconMap = {
  //[AgeRange.OVER_EIGHTEEN]: Icons.TreeIcon,
  //[AgeRange.THIRTEEN_TO_EIGHTEEN]: Icons.SproutIcon,
  //[AgeRange.UNDER_THIRTEEN]: Icons.AcornIcon,
};

const SeasonIconMap = {
  //   [Season.SPRING]: Icons.SpringIcon,
  //   [Season.SUMMER]: Icons.SummerIcon,
  //   [Season.FALL]: Icons.FallIcon,
  //   [Season.WINTER]: Icons.WinterIcon,
};

const AgeSchoolLevelIconMap = {
  //   [AgeSchoolLevel.ELEMENTARY]: Icons.ElementarySchoolIcon,
  //   [AgeSchoolOptions.HIGH_SCHOOL]: Icons.HighSchoolIcon,
  //   [AgeSchoolOptions.MIDDLE_SCHOOL]: Icons.MiddleSchoolIcon,
  //   [AgeSchoolLevel.COLLEGE]: Icons.CollegeIcon,
  //   [AgeSchoolLevel.MIDDLE_THIRTEEN_AND_OVER]: Icons.SproutIcon,
  //[AgeSchoolLevel.MIDDLE_TWELVE_AND_UNDER]: Icons.AcornIcon,
  //   [AgeSchoolLevel.HIGH_FRESHMAN]: Icons.FreshmanIcon,
  //   [AgeSchoolLevel.HIGH_JUNIOR_VARSITY]: Icons.JuniorIcon,
  //   [AgeSchoolLevel.HIGH_VARSITY]: Icons.VarsityIcon,
};

const UtilityIconMap = {
  add: Icons.AddIcon,
  //close: Icons.CloseIcon,
  checkboxEmpty: Icons.CheckboxEmptyIcon,
  checkboxSelected: Icons.CheckboxSelectedIcon,
  //radioEmpty: Icons.RadioEmptyIcon,
  //radioSelected: Icons.RadioSelectedIcon,
  checkmark: Icons.CheckmarkIcon,
  chevron: Icons.ChevronIcon,
  //emptyBench: Icons.EmptyBenchIcon,
  teams: Icons.TeamsIcon,
  appStarRating: Icons.AppStarRatingIcon,
  appstore: Icons.AppStoreIcon,
  //   playstore: Icons.PlayStoreIcon,
  plus: Icons.PlusIcon,
  magnify: Icons.MagnifyIcon,
  //   search: Icons.SearchIcon,
  //   handle: Icons.HandleIcon,
  //   filter: Icons.FilterIcon,
  //   stats: Icons.StatsIcon,
  roster: Icons.RosterIcon,
  //   remove: Icons.RemoveIcon,
  //   rosterNew: Icons.RosterNewIcon,
  //   rosterPrevious: Icons.RosterPreviousIcon,
  //   rosterMaxPreps: Icons.RosterMaxPreps,
  //   phone: Icons.PhoneIcon,
  schedule: Icons.CalendarIcon,
  //   jersey: Icons.JerseyIcon,
  //   shareClips: Icons.ShareClipsIcon,
  //   inningHalf: Icons.InningHalfIcon,
  //   videoArchiveEmpty: Icons.VideoArchiveEmptyIcon,
  winnerArrow: Icons.WinnerArrowIcon,
  //   leftArrow: Icons.LeftArrow,
};

export const iconMap = {
  ...RSVPIconMap,
  ...InviteStatusIconMap,
  ...SportIconMap,
  ...CompetitionLevelIconMap,
  ...AgeRangeIconMap,
  ...SeasonIconMap,
  ...AgeSchoolLevelIconMap,
  ...StatusIconMap,
  ...UtilityIconMap,
};

export type StatusIcon = keyof typeof StatusIconMap;
export type RSVPStatusIcon = keyof typeof RSVPIconMap;
export type InviteStatusIcon = keyof typeof InviteStatusIconMap;
export type SportIcon = keyof typeof SportIconMap;
export type CompetitionLevelIcon = keyof typeof CompetitionLevelIconMap;
export type AgeRangeIcon = keyof typeof AgeRangeIconMap;
export type SeasonIcon = keyof typeof SeasonIconMap;
export type AgeSchoolLevelIcon = keyof typeof AgeSchoolLevelIconMap;
export type UtilityIcon = keyof typeof UtilityIconMap;
export type IconType = keyof typeof iconMap;
interface Props extends IconProps {
  type: IconType;
}

export const Icon = ({ type, fill, stroke, size }: Props) => {
  const Component = iconMap[type];

  if (!Component) {
    return null;
  }

  return <Component fill={fill} stroke={stroke} size={size} />;
};

export type { IconSize };
